export default __webpack_public_path__ + "static/pakora-2e1f34e71f1d9762e733cf13c33ee21c.png";